import { z } from 'zod';

// ====================================================================
// Skema untuk Validasi ID Penghapusan Pengguna
// ====================================================================

/**
 * Skema Zod untuk memvalidasi data yang diperlukan untuk menghapus pengguna.
 * Dalam kasus ini, kita hanya perlu memvalidasi bahwa ID pengguna
 * adalah string dengan format UUID yang valid.
 * 
 * Ini adalah lapisan keamanan sisi klien untuk memastikan kita tidak
 * mencoba mengirim request dengan ID yang salah format ke API.
 */
export const DeleteUserV4Schema = z.object({
    /**
     * ID pengguna yang akan dihapus.
     * Wajib ada dan harus berupa UUID.
     */
    id: z.string().uuid({ message: "Invalid user ID format. Must be a UUID." }),
});


// ====================================================================
// Tipe TypeScript yang Diekspor
// ====================================================================

/**
 * Tipe TypeScript untuk data yang divalidasi,
 * diturunkan secara otomatis dari skema Zod.
 * Meskipun hanya berisi 'id', ini adalah praktik yang baik untuk
 * menjaga konsistensi.
 */
export type DeleteUserV4FormData = z.infer<typeof DeleteUserV4Schema>;